import { TrackableLinkInteractionsDateRange, TrackableLinkInteractionsPeriod } from "@/protocols/trackableLinks"

export const MAX_CUSTOM_RANGE_IN_DAYS = 30

const PERIOD_TO_DAYS_BACK: Record<Exclude<TrackableLinkInteractionsPeriod, "custom">, number> = {
	today: 0,
	7: 6
}

export const calculateDateRangeForPeriod = (period: Exclude<TrackableLinkInteractionsPeriod, "custom">): TrackableLinkInteractionsDateRange => {
	const todayDate = new Date()

	const fromDate = new Date(todayDate)
	fromDate.setDate(todayDate.getDate() - PERIOD_TO_DAYS_BACK[period])
	fromDate.setHours(0, 0, 0, 0)

	const toDate = new Date(todayDate)
	toDate.setHours(23, 59, 59, 999)

	return { fromDate, toDate }
}

export const getCustomPeriodEndDateLimit = (startDate: Date | null): Date => {
	const todayDate = new Date()

	if (!startDate) {
		return todayDate
	}

	const maxByIntervalDate = new Date(startDate)
	maxByIntervalDate.setDate(startDate.getDate() + MAX_CUSTOM_RANGE_IN_DAYS)
	maxByIntervalDate.setHours(23, 59, 59, 999)

	return maxByIntervalDate > todayDate ? todayDate : maxByIntervalDate
}
